

























import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ErrorCircleIcon } from 'tdesign-icons-vue';
import { InvalidFilenameInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/invalidFilename';

export default defineComponent({
  name: 'ShowInvalidFilenameDialog',
  components: { ErrorCircleIcon },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    invalidFiles: {
      type: Array as PropType<InvalidFilenameInfo[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const innerVisible = computed({
      get: () => props.visible,
      set: value => emit('update:visible', value),
    });
    const handleConfirm = () => {
      emit('confirm');
      innerVisible.value = false;
    };
    return { innerVisible, handleConfirm };
  },
});
